/*
 * Conteúdo institucional (SEO) — Ariel Malhas
 * Expansão "Ver mais / Ver menos" sem bibliotecas externas.
 *
 * O texto NUNCA é removido nem recebe display:none — apenas max-height e
 * overflow mudam, garantindo que o Google indexe o conteúdo completo.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(card) {
    if (card.__aseoInit) return;
    card.__aseoInit = true;

    var content = card.querySelector('[data-aseo-content]');
    var btn = card.querySelector('[data-aseo-toggle]');
    if (!content || !btn) return;

    var collapsed = parseInt(card.getAttribute('data-collapsed'), 10) || 420;
    var labelMore = btn.getAttribute('data-label-more') || 'Ver mais';
    var labelLess = btn.getAttribute('data-label-less') || 'Ver menos';

    // Conteúdo menor que a altura recolhida: não há o que expandir.
    if (content.scrollHeight <= collapsed + 8) {
      content.classList.add('is-static');
      btn.hidden = true;
      return;
    }

    function expand() {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = labelLess;

      // Ao terminar a animação, libera a altura para o conteúdo poder
      // refluir (mudança de fonte, redimensionamento, etc.).
      var done = function () {
        if (content.classList.contains('is-open')) content.style.maxHeight = 'none';
      };
      if (REDUCED) done();
      else content.addEventListener('transitionend', done, { once: true });
    }

    function collapse() {
      // Sai de 'none' para um valor concreto antes de animar de volta.
      content.style.maxHeight = content.scrollHeight + 'px';
      content.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = labelMore;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          content.style.maxHeight = collapsed + 'px';
        });
      });

      // Volta ao topo da seção para o usuário não ficar "perdido" no meio.
      var target = card.closest('.ariel-about-section') || card;
      if (target.scrollIntoView) {
        target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      }
    }

    btn.addEventListener('click', function () {
      if (content.classList.contains('is-open')) collapse();
      else expand();
    });
  }

  function boot(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-aseo]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Suporte ao editor de temas do Shopify.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
